import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="confirm-allowances"
export default class extends Controller {
  static targets = [
    'newEmployeeForm',
  ]

  declare readonly newEmployeeFormTarget: HTMLFormElement

  static values = {
    confirm: String,
  }

  declare confirmValue: string

  connect () {
    window.addEventListener('allowancesConfirmed', this.handleConfirm.bind(this))
  }

  disconnect () {
    window.removeEventListener('allowancesConfirmed', this.handleConfirm.bind(this))
  }

  submit (event: SubmitEvent) {
    event.preventDefault()

    if (this.confirmValue === 'true') {
      const openConfirmation = new CustomEvent('confirmCurrentAllowances', {
        detail: { open: true, employeeIds: [], addAndInviteFlow: true },
      })
      window.dispatchEvent(openConfirmation)
    } else {
      this.newEmployeeFormTarget.requestSubmit()
    }
  }

  // If the employer admin confirms the current allowances, then the react component
  // dialog will emit a custom event to note that the allowances were confirmed which
  // this handler will pickup and then proceed to submit the form so that the new
  // employee is both added and invited in a single step.
  handleConfirm (event: Event) {
    const customEvent = event as CustomEvent

    if (customEvent.detail.confirmed) {
      this.newEmployeeFormTarget.requestSubmit()
    }
  }
}
